export default (value: number, step: number): number => {
  const m = value % step;
  return m > step / 2 ? value - m + step : value - m;
};
